export class FlowTemplate {
  description: string;
  errors: string[];
  id: number;
  name: string;
  automationType: string;
  previewImageUrl: string;
}
